import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    firstStep: 'Unstake your old {token} tokens',
    secondStep:
      'Stake them again to receive the new and<br /> improved version of {token}',
  },
};
